import { Button } from "@/atoms-react/button/Button.react";
import Column from "@/atoms-react/column/Column.react";
import type { LayoutBaseProps } from "@/atoms-react/layout-base/LayoutBase.react";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@/atoms-react/input-checkbox/index.react";
import { A } from "@/atoms-react/a/A.react";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { CGU_TYPE, type CguType } from "@/features/cgu/types";

interface EnterPhoneProps extends LayoutBaseProps {
  onValidated?: (data: CguType) => void;
  cguList: CguType[];
  loadingCheck: boolean;
}

function CguMissing({ onValidated = () => {}, cguList, loadingCheck }: EnterPhoneProps) {
  const { t } = useTranslation(["pass"]);
  const [cgu, setCgu] = useState(false);

  const { getLanguage } = usei18n();

  function execute() {
    if (!cgu) {
      toast.error(t("flow.id_control.error.must_enter_fields"));
      return;
    }
    onValidated(cguList?.find((cgu: CguType) => cgu.Type === CGU_TYPE.REGISTER) as CguType);
  }
  return (
    <>
      <Column>
        <div className="mb-12 grow">
          <Checkbox value={cgu} onChange={(value) => setCgu(value)}>
            <span>
              {t("flow.id_control.signup.label.cgu_accept_1") + " "}
              <A
                href={
                  getLanguage() === "fr"
                    ? cguList?.find((cgu) => cgu.Type === CGU_TYPE.REGISTER)?.UrlFr
                    : cguList?.find((cgu) => cgu.Type === CGU_TYPE.REGISTER)?.UrlEn
                }
                target="_blank"
                rel="noreferrer"
                className="text-primary"
              >
                {t("flow.id_control.signup.label.cgu_accept_2_link")}
              </A>
              {t("flow.id_control.signup.label.cgu_accept_3")}
            </span>
          </Checkbox>
        </div>
        <Button
          disabled={!cgu}
          loading={loadingCheck}
          shortcut="enter"
          className="shrink-0"
          onClick={() => execute()}
          icon={<ChevronRightIcon />}
        >
          {t("flow.id_control.input.continue")}
        </Button>
      </Column>
    </>
  );
}

export default CguMissing;
